var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconStopClock = function SvgIconStopClock(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2201_37600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.00001 11.93C8.61784 11.93 10.74 9.80783 10.74 7.19C10.74 4.57217 8.61784 2.45 6.00001 2.45C3.38218 2.45 1.26001 4.57217 1.26001 7.19C1.26001 9.80783 3.38218 11.93 6.00001 11.93Z",
    stroke: "#072120",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 2.45V0.800003",
    stroke: "#072120",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 7.08001V4.46001",
    stroke: "#072120",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.77002 1.07001H7.23002",
    stroke: "#072120",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00008 8.11C6.50818 8.11 6.92008 7.69811 6.92008 7.19C6.92008 6.6819 6.50818 6.27 6.00008 6.27C5.49198 6.27 5.08008 6.6819 5.08008 7.19C5.08008 7.69811 5.49198 8.11 6.00008 8.11Z",
    fill: "#072120"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2201_37600"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconStopClock);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-stop-clock.18b34f97458c4ffd1b31379ada1cffab.svg";